import { SocialNetwork } from '@shared/interfaces/social-networks.interface';

export const SOCIAL_NETWORKS: SocialNetwork[] = [
  {
    name: 'Twitter',
    url: 'https://x.com/Segurosreservas?mx=2',
    icon: 'twitter',
    alt: 'twitter-icon',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/segurosreservasrd/',
    icon: 'instagram',
    alt: 'instagram-icon',
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/segurosreservas/',
    icon: 'facebook',
    alt: 'facebook-icon',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/seguros-reservas/?originalSubdomain=do',
    icon: 'linkedin',
    alt: 'linkedin-icon',
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/SegBanReservas',
    icon: 'youtube',
    alt: 'youtube-icon',
  },
];
